import commonUtils from '@/js/workspace/common_util.js';

export default {
    addOffLineTask(ud, type, n, url, toItems, options) {
        this.ud = ud;
        this.type = type;
        this.n = n;
        this.url = url;
        this.toItems = toItems;
		this.options = options;
    },
	addParseFailedTask(ud, type, toItem, name) {
	    this.ud = ud;
		this.type = type;
		this.toItem = toItem;
		this.name = name;
	},
    addTorrentTask(ud, id, type, fileList, toItem, size, options) {
        this.ud = ud;
        this.id = id;
        this.type = type;
        this.totalSize = 0;
        this.selectedSize = size;
        this.fileList = fileList;
        this.toItem = toItem;
		this.options = options;
    },
	betchDeleteOfflineTask(ud,dd){
		this.deleteUrl(ud,dd);
		this.deleteTorrent(ud,dd);
	},
	deleteUrl(ud,dd){
		let deleteData = {
			ud: ud,
			toItems:[{
				driveId : dd
			}],
			type : 3,
			bh:true
		};
		return deleteData;
		},
	deleteTorrent(ud,dd){
		let deleteData = {
			ud: ud,
			toItem:{
				driveId : dd
			},
			type : 5
		};
		return deleteData;
	},
}


// WEBPACK FOOTER //
// ./src/js/workspace/task_offline_util.js